export const navigation = () => {
    const navbarToggler = document.querySelector('.navbar--toggler');
    const body = document.body;

    if (navbarToggler) {
        navbarToggler.addEventListener('click', () => {
            body.classList.toggle('menu-is-open');
        });
    }

    const backToTop = document.querySelector('.back-to-top--link');

    if (backToTop) {
        backToTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
};
